export default __webpack_public_path__ + "static/media/2.d07e374a.jpg";